import React, { useContext } from "react";

import NoData from "../../NewComponents/NoData";
import { DataContext } from "../../Context/DataContext";
import { searchClientAlgolia } from "../../firebase.config.js";
import AccountOrdersComponent from "./OrdersComponents.js";
import { InstantSearch } from "react-instantsearch-hooks-web";
import Loader from "../../NewComponents/Loader.js";

const Orders = ({ windowSize }) => {
 
  const { userData } = useContext(DataContext);

  if(!userData){
    return <div className="container mx-auto w-full h-dvh flex items-center justify-center">
            <Loader />
          </div>
  }

  return (
    <>
      {/* <TopBar /> */}
    <InstantSearch searchClient={searchClientAlgolia} indexName="orders" >
      <AccountOrdersComponent windowSize={windowSize}/>
      </InstantSearch>
    </>
  );
};

export default Orders;
